import { GET, POST, POST_PARTNER, PUT } from "./_config";

//user
export const getSurveyQuestions = async () =>
  await GET("/survey/questions-list");

export const surveyResultIframe = async (body, headers) =>
  await POST_PARTNER("/survey/survey-result", body, headers);

export const surveyResult = async (body) =>
  await POST("/survey/survey-result", body);

export const sendSurveyResult = async (body) =>
  await POST("/survey/send-email", body, false, 120000);

export const getSurveyPdf = async (body) =>
  await POST("/survey/survey-results-pdf", body, false, 120000);

//admin
export const getSurveyResultList = async (query) =>
  await GET(`/survey?${query || ""}`, true);

export const getSurveyQuestionList = async () =>
  await GET("/survey/questions", true);

export const updateSurveyQuestionById = async (id, body) =>
  await PUT(`/survey/questions?id=${id}`, body, true);

export const exportSurveyResults = async (query, format) =>
  GET(`/survey/export?${query}&format=${format}`, true);
